var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h4',{staticClass:"title is-4"},[_vm._v(_vm._s(_vm.chartName))]),_c('app-chart-time-frames'),_c('div',{attrs:{"id":"chartdiv"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }